import React, { useCallback } from 'react'
import translate from 'core/translate'
import { useTemplateEditorContext } from '../hooks/templateEditorContext'
import { LEFT_PANE_MIN_HEIGHT } from '../hooks/useTemplateEditorLeftPaneState'
import { TemplateEditorCatalogPane } from './templateEditor__catalogPane'
import { TemplateEditorLayersList } from './templateEditor__layersList'
import { TemplateEditorLeftPane, TemplateEditorPanelSplitter } from './templateEditor__leftPane'
import { TemplateEditorTemplatesPane } from './templateEditor__templatesPane'
import styles from './templateEditor__leftPanels.jcss'

export const TemplateEditorLeftPanels = () => {
    const {
        collapsedPanes,
        paneHeights,
        elements,
        selectedIds,
        togglePane,
        setPaneHeight,
        selectElement,
        toggleLock,
        toggleHidden,
        reorderLayers,
        reorderGroupLayers,
        bringToFront,
        sendToBack,
        bringForward,
        sendBackward,
        duplicateSelection,
        deleteSelection,
    } = useTemplateEditorContext()

    const resizeTemplates = useCallback(
        (deltaY: number) => {
            setPaneHeight('templates', paneHeights.templates + deltaY)
        },
        [paneHeights.templates, setPaneHeight]
    )

    const resizeLayers = useCallback(
        (deltaY: number) => {
            setPaneHeight('layers', paneHeights.layers - deltaY)
        },
        [paneHeights.layers, setPaneHeight]
    )

    return (
        <aside className={styles.leftPanels}>
            <div className={styles.leftSplit}>
                <TemplateEditorTemplatesPane />

                <TemplateEditorPanelSplitter
                    onResize={resizeTemplates}
                    disabled={collapsedPanes.templates || collapsedPanes.catalog}
                />

                <TemplateEditorCatalogPane collapsed={collapsedPanes.catalog} onToggle={() => togglePane('catalog')} />

                <TemplateEditorPanelSplitter
                    onResize={resizeLayers}
                    disabled={collapsedPanes.layers || collapsedPanes.catalog}
                />

                <TemplateEditorLeftPane
                    paneId="layers"
                    title={translate('templateEditorLayers')}
                    collapsed={collapsedPanes.layers}
                    onToggle={() => togglePane('layers')}
                    height={Math.max(paneHeights.layers, LEFT_PANE_MIN_HEIGHT)}
                >
                    <TemplateEditorLayersList
                        elements={elements}
                        selectedIds={selectedIds}
                        onSelect={(id, additive) => selectElement(id, additive, true)}
                        onToggleHidden={(id) => toggleHidden([id])}
                        onToggleLock={(id) => toggleLock([id])}
                        onReorder={reorderLayers}
                        onReorderGroup={reorderGroupLayers}
                        onBringToFront={(id) => bringToFront([id])}
                        onSendToBack={(id) => sendToBack([id])}
                        onBringForward={(id) => bringForward([id])}
                        onSendBackward={(id) => sendBackward([id])}
                        onDuplicate={duplicateSelection}
                        onDelete={deleteSelection}
                    />
                </TemplateEditorLeftPane>
            </div>
        </aside>
    )
}
